/* src/services/api.js */
import axios from 'axios'

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  timeout: 10000
})

apiClient.interceptors.request.use(config => {
  
  const token = localStorage.getItem('admin_token') || localStorage.getItem('user_token')

  if (token) {

    config.headers.Authorization = `Token ${token}`
  }

  return config
})

apiClient.interceptors.response.use(
  response => response,
  error => {

    if (error.response && error.response.status === 401) {

      console.warn("Token non valido o scaduto.")
      localStorage.removeItem('admin_token')
      localStorage.removeItem('user_token')
    }

    return Promise.reject(error)
  }
)

export default apiClient